import React, {useState} from 'react';
import Swal from "sweetalert2"
import {FaEye} from 'react-icons/fa';
import {FaEyeSlash} from 'react-icons/fa';

import '../../styles/tarjetaContenedor.css'
import '../../styles/login.css'
/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, usersCollection } from '../../firebase/config';

/**
 * Componentes
 */
//Componente que contiene los elementos del Header del sitio
import Header from '../components/header';
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from '../components/encabezadoSeccion';
//Componente que contiene los elementos del Footer del sitio
import Footer from '../components/footer';
//Componente que contiene el modal que indica si hubo un error al accesar
import LoginModal from '../components/loginModal';
//import ConfiguracionModal from '../components/configuracionModal';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { cifrar } from '../../utils/functions';

const customStyles = {
    margin:"50px auto"
  };

/**
 * Page asignada al acceso al sistema
 * @param {Object} param0 Recibe los objetos necesarios para guardar la información de sesión
 * @returns Component Devuelve el sitio con los elementos y funcionalidad asignada
 */
const Login = ({setuserNomHospital,setUserName,setUserIslogged,setUserLevel,access}) => {

    //Estado que almacena la lista de unidades disponibles
    //const [buildingArray,setBuildingArray]=useState([])
    //Estado que almacena si se debe mostrar el modal de error de acceso
    const [isVisible, setIsVisible] = useState(false)
    //Estado que almacen el mensaje a mostrar en el modal de error de acceso
    const [message,setMessage] = useState("Información de acceso no encontrada")
    //Estado que almacena el nick de acceso proporcionado por el usuario
    const [nick,setNick] = useState("")
    //Estado que almacena el password de acceso proporcionado por el usuario
    const [pass,setPass] = useState("")
    //Estado que indica si se muestran los caracteres del password de acceso
    const [seMuestra,setSeMuestra] = useState(false)
    //Estado que almacena el nombre de la unidad hospitalaria del usuario que intenta ingresar al sistema
    //const [uh, setUH]=useState("")
    //Estado que almacena el usuario que esta intendo accesar al sistema
    //const [userTryToLogged,setUserTryToLogged]=useState({})
    
    //Estilo asignado al icono de la tarjeta para password de acceso
    const styleIcon = { color: "black", margin: "3px auto 3px", height: "18px", fontSize:"3.0em"}
    
    /**
     * Función que oculta el modal de error de acceso
     * @returns Devuelve el estado del componente
     */
    const hideModal = () => setIsVisible(false);


    /**
     * Función que solicita se configure el uso que se le dará al dispositivo
     * @param {Object} user Recibe el usuario que intenta accesar al sistema
     * @param {String} unidadHospitalaria Recibe el nombre de la unidad hospitalaria a la que pertenece el usuario
     */
    // const setConfiguracion = async (user, unidadHospitalaria) => {
    //     const buildingQuery = await pacientesStore.collection(building).get()
    //     let buildingList = []
    //     buildingQuery.forEach(snap => {
    //         buildingList.push({ id: snap.id, ...snap.data() })
    //     });
    //     buildingList.sort(compararInformación('Building_Id'))
    //     setBuildingArray(buildingList)
    //     setUserTryToLogged(user)
    //     setUH(unidadHospitalaria)
    //     document.getElementById('configuracionModal').style.display='block'
    // }

    /**
     * Función que permite comprobar si el usuario tiene acceso y guardar su respectiva sesión
     */
    const getLogin = () => {
        pacientesStore.collection(usersCollection)
            .onSnapshot(snap => {
                const users = []
                snap.forEach(doc => {
                  users.push({ id: doc.id, ...doc.data() })
                })

                let mensaje = "Información de acceso no encontrada"
                let userFound = false
                setMessage("Información de acceso no encontrada")
                for(let i=0;i<users.length;i++){
                    let unidadHospitalaria = users[i].UnidadHospitalaria
                  if(users[i].Nick === nick && users[i].Pass === pass){
                    let isAutorized = false
                    if(users[i].Systems){
                        for(let j=0;j<users[i].Systems.length;j++){
                            if(users[i].Systems[j].id === 1 && users[i].Systems[j].active){
                                isAutorized = true
                            }
                        }
                    }
                    else{
                        isAutorized = true
                    }
                    if(users[i].Activo){
                        if(isAutorized){
                            mensaje = "Usuario activado exitosamente"
                            userFound = true
                            sessionStorage.setItem('id',users[i].id)
                            sessionStorage.setItem('nomHospital',cifrar(unidadHospitalaria.id))
                            setuserNomHospital(cifrar(unidadHospitalaria.id))
                            sessionStorage.setItem('name',cifrar(users[i].Nombre))
                            setUserName(cifrar(users[i].Nombre))
                            sessionStorage.setItem('level',users[i].Permiso)
                            setUserLevel(users[i].Permiso)
                            sessionStorage.setItem('logged',true)
                            setUserIslogged(true)
                        }
                        else{
                            mensaje = "Usuario solo con acceso al sistema de agenda de quirófano"
                            //setMessage("Usuario solo con acceso al sistema de momentos de quirófano")
                            sessionStorage.setItem('nomHospital','')
                            setuserNomHospital('')
                            sessionStorage.setItem('name','')
                            setUserName('')
                            sessionStorage.setItem('level','')
                            setUserLevel('')
                            sessionStorage.setItem('logged',false)
                            setUserIslogged(false)
                        }
                    }
                    else{
                        mensaje = "Usuario sin acceso"
                        setMessage("Usuario sin acceso")
                        sessionStorage.setItem('nomHospital','')
                        setuserNomHospital('')
                        sessionStorage.setItem('name','')
                        setUserName('')
                        sessionStorage.setItem('level','')
                        setUserLevel('')
                        sessionStorage.setItem('logged',false)
                        setUserIslogged(false)
                    }
                  }
                }
                if(!userFound){
                    if(sessionStorage.getItem('logged') !== true){
                        Swal.fire({
                            icon: "warning",
                            title:'Error al acceder',
                            text:mensaje,
                            confirmButtonText:"Aceptar",
                            confirmButtonColor: "#04afaa"
                        })
                    }
                }   
            },(error)=>{
                setMessage(error)
                sessionStorage.setItem('nomHospital','')
                setuserNomHospital('')
                sessionStorage.setItem('name','')
                setUserName('')
                sessionStorage.setItem('level','')
                setUserLevel('')
                sessionStorage.setItem('logged',false)
                setUserIslogged(false)
                if(sessionStorage.getItem('logged') !== true){
                    Swal.fire({
                        icon: "error",
                        title:'Error al acceder',
                        text:error,
                        confirmButtonText:"Aceptar",
                        confirmButtonColor: "#04afaa"
                    })
                }
            })
      }
    
    /**
    * Función que atrapa el evento click de ingreso y dispara su validación
    * @returns Devuelve el estado del objeto
    */
    const handleIngresarClick = () => (event) => {
        event.preventDefault()
        if(nick && pass){
            getLogin()
        }
    }

    /**
     * Función que atrapa el evento click de cancelar y limpia el formulario
     * @returns Devuelve el estado del objeto
     */
    const handleCancelarClick = () => (event) => {
        event.preventDefault()
        setNick("")
        setPass("")
    }
    
    /**
     * Función que atrapa el evento de mostrar/ocultar caracteres del password
     * @returns Devuelve el estado del objeto
     */
     const handleMostrarClick = () => (event) => {
        event.preventDefault()
        setSeMuestra(!seMuestra)
    }

    return(
        <>
            <div className='seccionCabeceraLogin'>
                <Header access={access}/>
                {/* <EncabezadoSeccion tituloInicial={"Pacientes pendientes de "} tituloFinal={"salida de quirófano"} imgSource={"https://hospitalesmac.com/img/icono_16.png"}/> */}
                <EncabezadoSeccion tituloInicial={"Cirugías "} tituloFinal={"Hospitales MAC"} imgSource={"https://hospitalesmac.com/img/icono_16.png"}/>
            </div>
            <div className='cuerpoLogin'>
                <div className="login">
                    <form id="msform" onSubmit={handleIngresarClick()} style={customStyles}>
                        <h2 className="itemblogTitle">Accesar</h2>
                        <h3 className="info_itemblog">Usuario</h3>
                        <div className="text-containerLogin">
                            <input type="text" 
                                name="nick" 
                                value={nick} 
                                placeholder="Ingrese su user de acceso"
                                onChange={(event) => setNick(event.target.value.replace(/\s/g, ''))}
                            />
                        </div>
                        <h3 className="info_itemblog">Password</h3>
                        <div className="text-containerLogin">
                            <input 
                                type={seMuestra?"text":"password"} 
                                name="pass" 
                                value={pass} 
                                placeholder="Ingrese su password de acceso"
                                onChange={(event) => setPass(event.target.value.replace(/\s/g, ''))}
                            />
                            <span className='clearBtn' onClick={handleMostrarClick()}>
                                {
                                    seMuestra?<FaEyeSlash style={styleIcon}/>
                                    :<FaEye style={styleIcon}/>
                                }
                            </span>
                        </div>
                        <br />
                        <br />
                        <input type="submit" name="previous" className="previous action-button" value="Ingresar" onClick={handleIngresarClick()}/>
                        <input type="button" name="submit" className="submit limpiar-button" value="Cancelar" onClick={handleCancelarClick()}/>
                    </form>
                </div>
                <Footer />
            </div>
            {
                isVisible && <LoginModal message={message} isVisible={isVisible} hideModal={hideModal} />
            }
        </>
    )
}

export default Login;